import { ChakraBox, FAIconName, Icon } from '@equip.health/ui';

interface BadgeIconProps {
  size?: 'sm' | 'md' | 'lg';
  withBackground?: boolean;
}

/**
 * Badge icon using Font Awesome fa-badge-check
 */
const BadgeIcon = ({ size = 'md', withBackground = false }: BadgeIconProps) => {
  const icon = (
    <Icon
      color={'accent.blue'}
      name={FAIconName.badgeCheckRegular}
      size={size}
    />
  );

  if (withBackground) {
    return (
      <ChakraBox
        backgroundColor="white"
        borderRadius="50%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          '& svg': {
            fontSize: '20px', // Adjust the icon size within the background
          },
        }}
      >
        {icon}
      </ChakraBox>
    );
  }

  return icon;
};

export default BadgeIcon;
